import {
  MasterArtworkNameActionType,
  MasterArtworkNameActionTypes,
  MasterArtworkNameState,
} from "./data.type";
import {
  MasterArtworkCollectionActionType,
  MasterArtworkCollectionActionTypes,
  MasterArtworkCollectionState,
} from "../collections/data.type";
import { ILicensedProperty, ILicensor, IRequestStatusReason } from "../../../types/data.interface";

const setArtworkName = (
  artworkName: MasterArtworkNameState,
): MasterArtworkNameActionType => ({
  type: MasterArtworkNameActionTypes.SET_ARTWORK_NAME,
  payload: { ...artworkName },
});

const resetState = (): MasterArtworkNameActionType => ({
  type: MasterArtworkNameActionTypes.RESET_STATE,
  payload: {},
});


const setName = (name: string): MasterArtworkNameActionType => ({
  type: MasterArtworkNameActionTypes.SET_NAME,
  payload: { name },
});

const setCode = (code: string): MasterArtworkNameActionType => ({
  type: MasterArtworkNameActionTypes.SET_CODE,
  payload: { code },
});

const setLaunchDate = (launch_date: string): MasterArtworkNameActionType => ({
  type: MasterArtworkNameActionTypes.SET_LAUNCH_DATE,
  payload: { launch_date },
});

const setId = (id: number | string) => ({
  type: MasterArtworkNameActionTypes.SET_ID,
  payload: { id },
});

const setCollection = (collection: MasterArtworkCollectionState | null) => ({
  type: MasterArtworkNameActionTypes.SET_COLLECTION,
  payload: { collection },
});

const setArtworkNumberCode = (artwork_number_code: string | null) => ({
  type: MasterArtworkNameActionTypes.SET_ARTWORK_NUMBER_CODE,
  payload: { artwork_number_code },
});

const setSubmitComment = (comment: string): MasterArtworkNameActionType => ({
  type: MasterArtworkNameActionTypes.SET_SUBMIT_COMMENT,
  payload: { submitComment: comment },
});

const setApproveComment = (comment: string): MasterArtworkNameActionType => ({
  type: MasterArtworkNameActionTypes.SET_APPROVE_COMMENT,
  payload: { approveComment: comment },
});

const setRejectComment = (comment: string): MasterArtworkNameActionType => ({
  type: MasterArtworkNameActionTypes.SET_REJECT_COMMENT,
  payload: { rejectComment: comment },
});

const setRejectReason = (
  reason: IRequestStatusReason,
): MasterArtworkNameActionType => ({
  type: MasterArtworkNameActionTypes.SET_REJECT_REASON,
  payload: { rejectReason: reason },
});

const setArtworkNumberFileName = (
  fileUrl: string | null,
): MasterArtworkNameActionType => ({
  type: MasterArtworkNameActionTypes.SET_ARTWORK_NUMBER_FILE_NAME,
  payload: { artwork_number_file_url: fileUrl },
});

const setRequestStatus = (
  requestStatus: string | null,
): MasterArtworkNameActionType => ({
  type: MasterArtworkNameActionTypes.SET_REQUEST_STATUS,
  payload: { requestStatus },
});

const setIsValid = (isValid: boolean | null): MasterArtworkNameActionType => ({
  type: MasterArtworkNameActionTypes.SET_IS_VALID,
  payload: { isValid },
});

const setIsReadOnly = (
  isReadOnly: boolean,
): MasterArtworkNameActionType => ({
  type: MasterArtworkNameActionTypes.SET_IS_READ_ONLY,
  payload: { isReadOnly },
});

const setUnsavedChanges = (
  hasUnsavedChanges: boolean,
): MasterArtworkNameActionType => ({
  type: MasterArtworkNameActionTypes.SET_UNSAVED_CHANGES,
  payload: { hasUnsavedChanges },
});

const setFiltersFromStorage = (
  filters: Partial<MasterArtworkNameState>,
): MasterArtworkNameActionType => ({
  type: MasterArtworkNameActionTypes.SET_FILTERS_FROM_STORAGE,
  payload: { ...filters },
});

const resetAllData = (): MasterArtworkNameActionType => ({
  type: MasterArtworkNameActionTypes.RESET,
  payload: {},
});

export const MasterArtworkNameActions = {
  setArtworkName,
  setName,
  setCode,
  setLaunchDate,
  setId,
  setCollection,
  setArtworkNumberCode,
  setSubmitComment,
  setApproveComment,
  setRejectComment,
  setRejectReason,
  setArtworkNumberFileName,
  setIsValid,
  setRequestStatus,
  resetState,
  setIsReadOnly,
  setUnsavedChanges,
  setFiltersFromStorage,
  resetAllData
};
